import { LitElement, html, css, unsafeCSS, nothing } from 'lit';
import styles from './dropdown-item.scss?inline';

export default class SotbitDropdownItem extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        active: { type: Boolean },
        value: { type: String },
    };

    constructor() {
        super();

        this.active = false;
        this.value = null;
    }

    render() {
        return html`<div class="dropdown-item" part="dropdown-item">
            <slot name="icon-left"></slot>
            <slot name="value"></slot>
            <slot name="icon-right">
                ${this.active ? html` <sotbit-icon icon="check" variant="simple" size="s"></sotbit-icon> ` : nothing}
            </slot>
        </div>`;
    }
}
